<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rawat Inap" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div class="d-flex flex-between my-3">
            <h4 class="text-uppercase mb-0">data rawat jalan</h4>
            <div class="d-flex">
              <router-link
                :to="'/ralan/detail/' + idRalan"
                target="_blank"
                class="btn btn-with-icon-left btn-secondary text-uppercase"
              >
                <i class="material-symbols-outlined">open_in_new</i>
                Detail Data Rawat Jalan
              </router-link>
            </div>
          </div>
          <div class="row" v-if="detailLeftTop || detailRightTop">
            <div class="col-md-7 pr-1" v-if="detailLeftTop">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1" v-if="detailRightTop">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>
          <div class="d-flex flex-between my-3">
            <h4 class="text-uppercase mb-0">data rawat inap</h4>
            <div class="d-flex">
              <router-link
                :to="'/ranap/form/' + idRalan + '/edit/' + $route.params.id"
                class="btn btn-with-icon-left btn-primary text-uppercase mr-2"
              >
                <i class="material-symbols-outlined">create</i>
                Ubah Data
              </router-link>
            </div>
          </div>
          <div class="row" v-if="detailBottomLeft">
            <div class="col-md-7 pr-1">
              <DetailLeft :detailLeftTop="detailBottomLeft" />
            </div>
            <div class="col-md-5 pl-1">
              <DetailLeft :detailLeftTop="detailBottomRight" />
            </div>
          </div>

          <div class="row my-3">
            <div class="col-md-12">
              <b-tabs pills>
                <b-tab
                  title="DATA PEMERIKSAAN HARIAN"
                  :active="tabActive == 'pemeriksaan'"
                >
                  <div>
                    <div class="d-flex mt-3 mb-2 flex-between">
                      <div class>
                        <h4 class="text-uppercase mb-0">pemeriksaan harian</h4>
                      </div>
                      <div class="d-flex">
                        <router-link
                          :to="
                            '/ranap/form-petugas/' +
                              $route.params.id +
                              '?fromTab=pemeriksaan'
                          "
                          class="
                            btn btn-with-icon-left btn-primary
                            text-uppercase
                            mr-2
                          "
                        >
                          <i class="material-symbols-outlined">add</i>
                          Pemeriksaan Perawat
                        </router-link>
                        <router-link
                          :to="
                            '/ranap/form-dokter/' +
                              $route.params.id +
                              '?fromTab=pemeriksaan'
                          "
                          class="
                            btn btn-with-icon-left btn-secondary
                            text-uppercase
                            mr-2
                          "
                        >
                          <i class="material-symbols-outlined">add</i>
                          Pemeriksaan Dokter
                        </router-link>
                      </div>
                    </div>
                    <div v-if="periksaHarian && periksaHarian.length">
                      <div class="tab-days my-2">
                        <b-tabs nav-class="mt-4">
                          <b-tab
                            v-for="item in periksaHarian"
                            :title="item.formatted_tgl_periksa"
                            v-bind:key="String(item.id) + Math.random(1024)"
                            @click="() => setPeriksaHarian(item.tgl_periksa)"
                          />
                        </b-tabs>
                      </div>

                      <div v-if="loadedPeriksa">
                        <div class="d-flex flex-between my-3">
                          <h5 class="mb-2">Hasil Pemeriksaan perawat</h5>
                          <router-link
                            v-if="dataPetugasLeft || dataPetugasRight"
                            :to="
                              `/ranap/form-petugas/${$route.params.id}/edit/${form_petugas_id}?fromTab=pemeriksaan`
                            "
                            class="btn btn-with-icon-left btn-primary"
                          >
                            <i class="material-symbols-outlined">create</i>
                            Ubah Data
                          </router-link>
                        </div>
                        <div
                          class="row mb-4"
                          v-if="dataPetugasLeft || dataPetugasRight"
                        >
                          <div class="col-md-7 pr-1">
                            <DetailLeft :detailLeftTop="dataPetugasLeft" />
                          </div>
                          <div class="col-md-5 pl-1">
                            <DetailRight :detailRightTop="dataPetugasRight" />
                          </div>
                        </div>
                        <EmptyState v-else :data="emptyPtg" />
                        <div class="d-flex flex-between my-3">
                          <h5 class="mb-2">Hasil Pemeriksaan Dokter</h5>
                          <router-link
                            v-if="dataDokterLeft || dataDokterRight"
                            :to="
                              `/ranap/form-dokter/${$route.params.id}/edit/${form_dokter_id}?fromTab=pemeriksaan`
                            "
                            class="btn btn-with-icon-left btn-primary"
                          >
                            <i class="material-symbols-outlined">create</i>
                            Ubah Data
                          </router-link>
                        </div>
                        <div
                          class="row mb-4"
                          v-if="dataDokterLeft || dataDokterRight"
                        >
                          <div class="col-md-6">
                            <DetailRight :detailRightTop="dataDokterLeft" />
                          </div>
                          <div class="col-md-6">
                            <DetailRight :detailRightTop="dataDokterRight" />
                          </div>
                        </div>
                        <EmptyState v-else :data="emptyDok" />
                      </div>
                      <Loading v-else></Loading>
                    </div>
                    <EmptyState v-else :data="emptyPeriksa" />
                  </div>
                </b-tab>
                <b-tab
                  title="DATA TINDAKAN HARIAN"
                  :active="tabActive == 'tindakan'"
                >
                  <div>
                    <div class="d-flex mt-3 mb-2 flex-between">
                      <div class>
                        <h4 class="text-uppercase mb-0">tindakan harian</h4>
                      </div>
                      <div class="d-flex">
                        <router-link
                          :to="
                            '/ranap/form-tindakan/' +
                              $route.params.id +
                              '?fromTab=tindakan'
                          "
                          class="
                            btn btn-with-icon-left btn-secondary
                            text-uppercase
                            mr-2
                          "
                        >
                          <i class="material-symbols-outlined">add</i>Tambah
                          Tindakan
                        </router-link>
                      </div>
                    </div>
                    <div v-if="tindakanHarian && tindakanHarian.length">
                      <div class="tab-days my-2">
                        <b-tabs nav-class="mt-4">
                          <b-tab
                            v-for="item in tindakanHarian"
                            :title="item.formatted_tgl_tindakan"
                            v-bind:key="String(item.id) + Math.random(1024)"
                            @click="() => setTindakanHarian(item.tgl_tindakan)"
                          />
                        </b-tabs>
                      </div>
                      <div v-if="loadedTindakan">
                        <div class="d-flex flex-between my-3">
                          <h4 class="mb-0">Data Tindakan</h4>
                          <router-link
                            :to="
                              `/ranap/form-tindakan/${$route.params.id}/edit/${tgl_tindakan}?fromTab=tindakan`
                            "
                            class="
                              btn btn-with-icon-left btn-primary
                              text-uppercase
                            "
                          >
                            <i class="material-symbols-outlined">create</i>
                            ubah data tindakan
                          </router-link>
                        </div>
                        <div class="d-flex flex-between my-3">
                          <h5 class="mb-2">Penanganan oleh Dokter</h5>
                        </div>
                        <table class="responsive" v-if="doc.length">
                          <thead>
                            <th>KODE</th>
                            <th>NAMA PERAWATAN</th>
                            <th>KATEGORI PERAWATAN</th>
                            <th>TARIF/BIAYA</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in doc"
                              v-bind:key="String(item.id) + Math.random(1024)"
                            >
                              <td>{{ item.kode }}</td>
                              <td>{{ item.nama }}</td>
                              <td>{{ item.kategori }}</td>
                              <td>{{ item.formatted_biaya }}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div class="d-flex flex-between my-3">
                          <h5 class="mb-2">Penanganan oleh Petugas</h5>
                        </div>
                        <table class="responsive" v-if="nrs.length">
                          <thead>
                            <th>KODE</th>
                            <th>NAMA PERAWATAN</th>
                            <th>KATEGORI PERAWATAN</th>
                            <th>TARIF/BIAYA</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in nrs"
                              v-bind:key="String(item.id) + Math.random(1024)"
                            >
                              <td>{{ item.kode }}</td>
                              <td>{{ item.nama }}</td>
                              <td>{{ item.kategori }}</td>
                              <td>{{ item.formatted_biaya }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="d-flex flex-between my-3">
                          <h5 class="mb-2">
                            Penanganan oleh Dokter dan Petugas
                          </h5>
                        </div>
                        <table class="responsive" v-if="both.length">
                          <thead>
                            <th>KODE</th>
                            <th>NAMA PERAWATAN</th>
                            <th>KATEGORI PERAWATAN</th>
                            <th>TARIF/BIAYA</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in both"
                              v-bind:key="String(item.id) + Math.random(1024)"
                            >
                              <td>{{ item.kode }}</td>
                              <td>{{ item.nama }}</td>
                              <td>{{ item.kategori }}</td>
                              <td>{{ item.formatted_biaya }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- <div class="d-flex flex-between my-3">
                          <h5 class="mb-2">Pemeriksaan Lab</h5>
                        </div>
                        <table class="responsive">
                          <thead>
                            <th>KODE</th>
                            <th>NAMA PEMERIKSAAN LAB</th>
                            <th>TARIF/BIAYA</th>
                          </thead>
                          <tbody>
                            <tr v-for="item in lab" v-bind:key="String(item.id)+Math.random(1024)">
                              <td>{{item.kode}}</td>
                              <td>{{item.nama}}</td>
                              <td>{{item.formatted_biaya}}</td>
                            </tr>
                          </tbody>
                        </table> -->
                      </div>
                      <Loading v-else></Loading>
                    </div>
                    <EmptyState v-else :data="emptyTindakan" />
                  </div>
                </b-tab>
                <b-tab
                  title="PEMBERIAN OBAT HARIAN"
                  :active="tabActive == 'obat'"
                >
                  <div class="d-flex mt-3 mb-2 flex-between">
                    <div class>
                      <h4 class="text-uppercase mb-0">obat harian</h4>
                    </div>
                    <div class="d-flex">
                      <router-link
                        :to="
                          '/ranap/form-obat/' +
                            $route.params.id +
                            '?fromTab=obat&tgl_obat=' +
                            tgl_obat
                        "
                        class="
                          btn btn-with-icon-left btn-secondary
                          text-uppercase
                          mr-2
                        "
                      >
                        <i class="material-symbols-outlined">add</i>Tambah Obat
                      </router-link>
                    </div>
                  </div>
                  <div v-if="obatHarian && obatHarian.length">
                    <div class="tab-days my-2">
                      <b-tabs nav-class="mt-4">
                        <b-tab
                          v-for="item in obatHarian"
                          :title="item.formatted_created_at"
                          v-bind:key="String(item.id) + Math.random(1024)"
                          @click="() => setObatHarian(item.created_at)"
                        />
                      </b-tabs>
                    </div>

                    <div>
                      <div class="d-flex flex-between my-3">
                        <h4 class="mb-2">Resep Obat / Alkes</h4>
                        <div class="d-flex">
                          <router-link
                            :to="
                              `/ralan/cetak-resep-obat/${idRalan}?ranap_obat=1&tgl_obat=${tgl_obat}`
                            "
                            target="_blank"
                            class="btn btn-with-icon-left btn-basic mr-2"
                            v-if="obat.length"
                          >
                            <i class="material-symbols-outlined">print</i>
                            Cetak Resep Obat
                          </router-link>
                          <router-link
                            :to="
                              '/ranap/form-obat/' +
                                $route.params.id +
                                '?fromTab=obat&tgl_obat=' +
                                tgl_obat
                            "
                            class="btn btn-with-icon-left btn-primary"
                          >
                            <i class="material-symbols-outlined">create</i>
                            Ubah Resep Obat
                          </router-link>
                        </div>
                      </div>
                      <table class="responsive" v-if="obat.length">
                        <thead>
                          <th>
                            KODE / NAMA BARANG / JENIS OBAT / GOLONGAN OBAT
                          </th>
                          <!-- <th>LOKASI</th> -->
                          <th>HARGA/SATUAN</th>
                          <th>JUMLAH</th>
                          <th>EMBALASE</th>
                          <th>TUSLAH</th>
                          <th>ATURAN PAKAI</th>
                          <th>SUB TOTAL</th>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in obat"
                            v-bind:key="item.id + item.kode + Math.random(1024)"
                          >
                            <td>
                              {{ item.kode }} / {{ item.nama }} /
                              {{ item.jenis }} / {{ item.golongan_obat }}
                            </td>
                            <!-- <td>{{ item.lokasi }}</td> -->
                            <td>{{ item.formatted_harga }}</td>
                            <td>{{ item.jumlah }}</td>
                            <td>{{ item.formatted_embalase }}</td>
                            <td>{{ item.formatted_tuslah }}</td>
                            <td>{{ item.catatan_dokter }}</td>
                            <td>{{ item.formatted_sub_total }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <EmptyState v-else :data="emptyObat" />
                    </div>
                  </div>
                  <EmptyState v-else :data="emptyAllObat" />
                </b-tab>
                <b-tab
                  title="DATA PEMERIKSAAN LAB"
                  :active="tabActive == 'lab'"
                >
                  <div>
                    <div class="d-flex flex-between my-3">
                      <h4 class="text-uppercase mb-0">data pemeriksaan lab</h4>
                      <router-link
                        :to="
                          '/ranap/form-lab/' + $route.params.id + '?fromTab=lab'
                        "
                        class="
                          btn btn-with-icon-left btn-primary
                          text-uppercase
                        "
                      >
                        <i class="material-symbols-outlined">create</i>
                        Ubah Pemeriksaan Lab
                      </router-link>
                    </div>
                    <div v-if="lab && lab.length">
                      <div v-if="loadedLab">
                        <table class="responsive">
                          <thead>
                            <th>KODE</th>
                            <th>NAMA PEMERIKSAAN LAB</th>
                            <th>WAKTU PEMERIKSAAN</th>
                            <th>TARIF/BIAYA</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in lab"
                              v-bind:key="String(item.id) + Math.random(1024)"
                            >
                              <td>{{ item.kode }}</td>
                              <td>{{ item.nama }}</td>
                              <td>
                                {{
                                  item.status.toLowerCase() == "dibatalkan"
                                    ? item.status
                                    : item.timeStamp
                                }}
                              </td>
                              <td>{{ item.formatted_biaya }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <Loading v-else></Loading>
                    </div>
                    <EmptyState v-else :data="emptyLab" />
                  </div>
                </b-tab>
                <b-tab
                  title="TAGIHAN KAMAR INAP"
                  :active="tabActive == 'kamar'"
                >
                  <div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="d-flex flex-between my-3">
                          <div class>
                            <h4 class="text-uppercase mb-0">
                              tagihan kamar inap
                            </h4>
                          </div>
                          <div class="d-flex">
                            <router-link
                              :to="
                                '/ranap/form-tagihan/' +
                                  $route.params.id +
                                  '?fromTab=kamar'
                              "
                              class="btn btn-with-icon-left btn-secondary"
                            >
                              <i class="material-symbols-outlined">add</i>
                              INPUT DATA TAGIHAN
                            </router-link>
                          </div>
                        </div>
                        <table
                          class="responsive"
                          v-if="dataTagihan && dataTagihan.length"
                        >
                          <thead>
                            <th>TANGGAL</th>
                            <th>NAMA KAMAR</th>
                            <th>NO. KASUR</th>
                            <th>KELAS</th>
                            <th>TARIF/BIAYA</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dataTagihan"
                              v-bind:key="item.id"
                            >
                              <td>{{ item.formatted_tgl }}</td>
                              <td>{{ `${item.kamar_ranap.nama}` }}</td>
                              <td>{{ item.kamar_ranap.formatted_no_kasur }}</td>
                              <td>
                                {{ `${item.kamar_ranap.formatted_kelas}` }}
                              </td>
                              <td>
                                {{ item.formatted_biaya }}
                                <router-link
                                  class="
                                    btn btn-icon btn-primary btn-sm
                                    mr-2
                                    ml-3
                                  "
                                  :to="
                                    `/ranap/form-tagihan/${$route.params.id}/edit/${item.id}`
                                  "
                                >
                                  <i class="material-symbols-outlined"
                                    >create</i
                                  >
                                </router-link>
                                <!-- <button class="btn btn-icon btn-danger btn-sm">
                                  <i class="material-symbols-outlined">delete</i>
                                </button> -->
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="3"></td>
                              <td>
                                <h4 class="my-2">Total Tagihan</h4>
                              </td>
                              <td>
                                <h4 class="my-2 pr-4 mr-4">
                                  {{ convertToRupiah(totalTagihan) }}
                                </h4>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Loading from "@/components/Loading.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import EmptyState from "@/components/EmptyState.vue";
import {
  setPatientIntro,
  setPeriksaPetugas,
  setPeriksaDokter,
  getFullUrl,
  isEmpty,
  convertToRupiah,
} from "@/data/helper.js";
// import { HTTP } from "@/config.js";
let tabs = [
  { title: "data pemeriksaan harian", link: "pemeriksaan", active: true },
  { title: "data tindakan harian", link: "tindakan" },
  { title: "tagihan kamar inap", link: "tagihan" },
];
let data = {
  title: "Detail Rawat Inap",
  backBtn: "/ranap",
  actionBtn: [],
  breadcrumb: [
    { title: "Rawat Inap", link: "/ranap" },
    { title: "Detail Rawat Inap", active: true },
  ],
};

export default {
  name: "RanapDetail",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    DetailTop,
    DetailLeft,
    DetailRight,
    EmptyState,
    Loading,
  },
  data: function() {
    return {
      fromUrl: "",
      plainUrl: "",
      // backendUrl: "https://103.27.207.58/backend/public/storage",
      classes: {
        DIBATALKAN: "danger",
        DIJADWALKAN: "primary",
        BERLANGSUNG: "secondary",
        SELESAI: "success",
      },
      no_rawat: "",
      tgl_tindakan: "",
      form_dokter_id: null,
      form_petugas_id: null,
      loadedPeriksa: false,
      loadedTindakan: false,
      loadedTagihan: false,
      loadedLab: false,
      periksaHarian: [],
      tindakanHarian: [],
      obatHarian: [],
      idRalan: "",
      convertToRupiah: convertToRupiah,
      darurat: 0,
      test: "hahaha",
      data: data,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      detailBottomLeft: null,
      detailBottomRight: null,
      detailApproval: null,
      dataPetugasLeft: null,
      dataPetugasRight: null,
      dataOphthalmic: null,
      dataTabelOphthalmic: null,
      dataDokterLeft: null,
      dataDokterRight: null,
      dataTagihan: [],
      totalTagihan: 0,
      tabs: tabs,
      emptyPtg: {
        img: "/img/nurse.svg",
        title: "Belum Ada Pemeriksaan Perawat",
        content:
          "Isi data pemeriksaan perawat dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/ranap/form-petugas/" + this.$route.params.id,
        label: "Input Pemeriksaan Perawat",
      },
      emptyOph: {
        img: "/img/oph.svg",
        title: "Belum ada pemeriksaan ophthalmic",
        content:
          "Isi data pemeriksaan ophthalmic dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/ranap/form-ophthalmic/" + this.$route.params.id,
        label: "Input Pemeriksaan Ophthalmic",
      },
      emptyDok: {
        img: "/img/doctor.svg",
        title: "Belum ada pemeriksaan dokter",
        content:
          "Isi data pemeriksaan dokter dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/ranap/form-dokter/" + this.$route.params.id,
        label: "Input Pemeriksaan Dokter",
      },
      emptyTindakan: {
        img: "/img/oph.svg",
        title: "Belum ada data tindakan harian",
        content: "Isi data tindakan dengan mengeklik tombol di atas",
        size: "small",
        link: "",
        label: "",
      },
      emptyObat: {
        img: "/img/med.svg",
        title: "Belum ada resep obat",
        content: "Input resep obat dengan mengeklik tombol Ubah Resep Obat",
        size: "small",
        link: "",
        label: "",
      },
      emptyAllObat: {
        img: "/img/med.svg",
        title: "Belum ada resep obat",
        content: "Input resep obat dengan mengeklik tombol Tambah Obat",
        size: "small",
        link: "",
        label: "",
      },
      emptyLab: {
        img: "/img/oph.svg",
        title: "Belum ada data pemeriksaan lab",
        content: "Isi data pemeriksaan lab dengan mengeklik tombol di atas",
        size: "small",
        link: "",
        label: "",
      },
      emptyPeriksa: {
        img: "/img/nurse.svg",
        title: "Belum ada data pemeriksaan harian",
        content: "Isi data pemeriksaan dengan mengeklik tombol di atas",
        size: "small",
        link: "",
        label: "",
      },
      metodeBayar: ["Umum", "BPJS", "Asuransi Lain"],
      resiko: [
        "Rendah",
        "Rendah",
        "Rendah",
        "Rendah",
        "Sedang",
        "Sedang",
        "Sedang",
        "Sedang",
        "Tinggi",
        "Tinggi",
        "Tinggi",
      ],
      tabActive: "pemeriksaan",
      formSet: {
        id_petugas: "",
        id_petugas_lab: "",
        id_dokter: "",
        lab_type: "",
      },
      tgl_obat: "",
      doc: [],
      nrs: [],
      both: [],
      lab: [],
      obat: [],
      optik: [],
      resepOptik: null,
    };
  },
  methods: {
    fetchPeriksaHarian: async function(id) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ranap/pemeriksaan/harian/${id}`
        );
        //console.log(result);
        this.periksaHarian = result.data;
        if (this.periksaHarian.length) {
          this.setPeriksaHarian(this.periksaHarian[0].tgl_periksa);
        } else {
          this.loadedPeriksa = true;
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchTindakanHarian: async function(id) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ranap/tindakan/harian/${id}`
        );
        //console.log(result);
        this.tindakanHarian = result.data;
        if (this.tindakanHarian.length) {
          this.setTindakanHarian(this.tindakanHarian[0].tgl_tindakan);
        } else {
          this.loadedTindakan = true;
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchObatHarian: async function(id) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ranap/obat/harian/${id}`
        );
        console.log(result);
        this.obatHarian = result.data;
        let existArr = [];
        this.obatHarian = this.obatHarian.filter((item) => {
          if (existArr.indexOf(item.formatted_created_at) > -1) {
            return false;
          } else {
            existArr.push(item.formatted_created_at);
            return true;
          }
        });
        if (this.obatHarian.length) {
          this.setObatHarian(this.obatHarian[0].created_at);
        } else {
          this.loadedTindakan = true;
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchObat: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `ranap/resep/obat?no_rawat=${this.no_rawat}&tgl_periksa=${this.tgl_obat}`
        );
        //console.log(result);
        let self = this;
        let len = self.obat.length;
        for (var i = 0; i < len; i++) {
          self.obat.pop();
        }
        if (result.status == "200") {
          result.data.data.forEach((item) => {
            item.id_ralan_obat = item.id;
            item.id = item.obat.id;
            item.kode = item.obat.kode;
            item.nama = item.obat.nama;
            item.jenis = item.obat.jenis;
            item.lokasi = item.obat.lokasi;
            self.obat.push(item);
          });
          self.obat = self.obat.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
        }
      } catch (e) {
        //console.log(e);
      }
    },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `ranap/${this.$route.params.id}`
        );
        //console.log("====ranap detail data=====");
        //console.log(result);
        //console.log("====ranap detail data=====");
        if (result.status == "200") {
          //console.log("berhasil");
          // this.rows = result.data;
          //console.log(this.rows);
          let dataPasien = result.data.pasien;
          //console.log(dataPasien);
          let ranap = result.data;
          this.$set(this.data, "actionBtn", [
            {
              type: "status",
              className: `badge-${this.classes[ranap.status]}`,
              label: ranap.status,
            },
          ]);
          this.detailBottomLeft = [
            {
              key: String(Math.random(1023)),
              columns: [
                {
                  label: "Kamar Inap",
                  content:
                    ranap.kamar_ranap.nama +
                    " | " +
                    ranap.kamar_ranap.formatted_kelas,
                  icon: "hotel",
                  colwidth: 6,
                },
                {
                  label: "Nomor Kasur",
                  content: ranap.kamar_ranap.formatted_no_kasur,
                  icon: "radio_button_checked",
                  colwidth: 6,
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              columns: [
                {
                  label: "Waktu Check In",
                  content:
                    ranap.formatted_tgl_masuk + " " + ranap.formatted_jam_masuk,
                  icon: "apps",
                  colwidth: 6,
                },
                {
                  label: "Petugas Penanggung Jawab",
                  content: ranap.petugas.nama,
                  icon: "apps",
                  colwidth: 6,
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              columns: [
                {
                  label: "SOAP Perawat",
                  content: ranap.soap_perawat,
                  icon: "apps",
                  colwidth: 6,
                },
                {
                  label: "SOAP Dokter",
                  content: ranap.soap_dokter,
                  icon: "apps",
                  colwidth: 6,
                },
              ],
            },
          ];
          this.detailBottomRight = [
            {
              key: String(Math.random(1023)),
              columns: [
                {
                  label: "Surat Permintaan Ranap",
                  type: "file",
                  content: getFullUrl(
                    this.$store.state.baseStorageURL,
                    ranap.file_permintaan_ranap
                  ),
                  icon: "apps",
                  colwidth: 6,
                },
                {
                  label: "Pengkajian Awal Pasien",
                  type: "file",
                  content: getFullUrl(
                    this.$store.state.baseStorageURL,
                    ranap.file_pengkajian_awal
                  ),
                  icon: "apps",
                  colwidth: 6,
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              columns: [
                {
                  label: "Asesmen Ulg Rsk Jatuh",
                  type: "file",
                  content: getFullUrl(
                    this.$store.state.baseStorageURL,
                    ranap.file_asesmen_resiko
                  ),
                  icon: "apps",
                  colwidth: 6,
                },
                {
                  label: "Catatan Pemberian Obat",
                  type: "file",
                  content: getFullUrl(
                    this.$store.state.baseStorageURL,
                    ranap.file_catatan_obat
                  ),
                  icon: "apps",
                  colwidth: 6,
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              columns: [
                {
                  label: "Ringkasan Masuk",
                  type: "file",
                  content: getFullUrl(
                    this.$store.state.baseStorageURL,
                    ranap.file_ringkasan_masuk
                  ),
                  icon: "apps",
                  colwidth: 6,
                },
                {
                  label: "Resume Medis",
                  type: "file",
                  content: getFullUrl(
                    this.$store.state.baseStorageURL,
                    ranap.file_resume_medis
                  ),
                  icon: "apps",
                  colwidth: 6,
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              columns: [
                {
                  label: "Resume Medis Pasien Pulang",
                  type: "file",
                  content: getFullUrl(
                    this.$store.state.baseStorageURL,
                    ranap.file_resume_pulang
                  ),
                  icon: "apps",
                  colwidth: 12,
                },
              ],
            },
          ];
          //console.log(this.detailTop);

          let ralan = result.data.ralan;
          if (ralan.asal_rujukan) {
            let faskes = await this.$store.state.HTTP.get(
              `faskes/${ralan.asal_rujukan}`
            );
            if (faskes.status == "200") {
              ralan.asal_rujukan_formatted = faskes.data.nama;
            }
          }
          this.idRalan = ralan.id;
          this.darurat = ralan.darurat;
          this.no_rawat = ranap.no_rawat;
          await this.fetchPeriksaHarian(this.$route.params.id);
          await this.fetchTindakanHarian(this.$route.params.id);
          await this.fetchObatHarian(this.$route.params.id);
          await this.fetchObat(this.no_rawat);
          await this.fetchTagihan(this.$route.params.id);
          await this.fetchLab();
          //console.log(ralan);

          this.detailLeftTop = [
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "No. Registrasi   |    No. Rawat",
                  content: ralan.formatted_no_reg_rawat,
                  icon: "confirmation_number",
                },
                {
                  label: "Tanggal/Waktu Periksa",
                  content: ralan.formatted_tgl_jam_periksa,
                  icon: "access_time",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "Unit",
                  content: ralan.unit.nama,
                  icon: "label_outline",
                },
                {
                  label: "Jenis Periksa",
                  content: ralan.jen_periksa,
                  icon: "filter_center_focus",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 1,
              columns: [
                {
                  label: "Dokter yang Dituju",
                  content: ranap.dokter.formatted_nama,
                  icon: "person_pin",
                },
              ],
            },
          ];

          this.detailRightTop = [
            {
              label: "Metode Pembayaran",
              content: this.metodeBayar[parseInt(ralan.id_asuransi) - 1],
              icon: "payment",
            },
            {
              label: `Nomor Peserta ${
                this.metodeBayar[parseInt(ralan.id_asuransi) - 1]
              }`,
              content: ralan.no_peserta || "-",
              icon: "contacts",
            },
            {
              label: "Asal Rujukan",
              content: ralan.asal_rujukan_formatted || "Tanpa Rujukan",
              icon: "rotate_right",
            },
          ];
          //console.log(this.detailLeftTop);
          //console.log(this.detailRightTop);

          this.detailTop = setPatientIntro(dataPasien);
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    fetchTagihan: async function(id) {
      let self = this;
      try {
        let result = await this.$store.state.HTTP.get(
          `/ranap/tagihan/kamar?id_ranap=${id}`
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log(result);
          this.totalTagihan = 0;
          this.dataTagihan = result.data.data.map((item) => {
            self.totalTagihan += item.biaya;
            return item;
          });
          //console.log(this.dataTagihan);
        } else {
          //console.log(result.status);
        }
      } catch (e) {
        //console.log(e);
        // this.errors.push(e);
        // this.saveFailed=true;
      }
    },
    fetchTindakan: async function(tgl_tindakan) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ranap/tindakan/penanganan?no_rawat=${this.no_rawat}&tgl_tindakan=${tgl_tindakan}`
        );
        // console.log(
        //   `ranap/tindakan/penanganan?no_rawat=${this.no_rawat}&tgl_tindakan=${tgl_tindakan}`
        // );
        //console.log(tgl_tindakan);
        //console.log(result);
        let self = this;
        self.doc = [];
        self.nrs = [];
        self.both = [];
        if (result.status == "200") {
          //console.log(result.data);
          let tindDoc = result.data.penanganan_dokter;
          tindDoc.forEach((item) => {
            item.nama = item.tindakan.nama;
            item.kategori = item.tindakan.kategori;
            item.kode = item.tindakan.kode;
            item.id_ranap_tindakan = item.id;
            item.id = item.tindakan.id;
            self.doc = self.doc.concat(item);
          });
          self.doc = self.doc.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
          let tindBoth = result.data.penanganan_dokter_petugas;
          tindBoth.forEach((item) => {
            item.nama = item.tindakan.nama;
            item.kategori = item.tindakan.kategori;
            item.kode = item.tindakan.kode;
            item.id_ranap_tindakan = item.id;
            item.id = item.tindakan.id;
            self.both = self.both.concat(item);
          });
          self.both = self.both.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
          let tindNrs = result.data.penanganan_petugas;
          tindNrs.forEach((item) => {
            item.nama = item.tindakan.nama;
            item.kategori = item.tindakan.kategori;
            item.kode = item.tindakan.kode;
            item.id_ranap_tindakan = item.id;
            item.id = item.tindakan.id;
            self.nrs = self.nrs.concat(item);
          });
          self.nrs = self.nrs.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
          if (tindBoth.length) {
            self.formSet.id_petugas = String(tindBoth[0].id_petugas);
            self.formSet.id_dokter = String(tindBoth[0].id_dokter);
          } else {
            if (tindNrs.length) {
              self.formSet.id_petugas = String(tindNrs[0].id_petugas);
            }
            if (tindDoc.length) {
              self.formSet.id_dokter = String(tindDoc[0].id_dokter);
            }
          }
          //console.log(tindDoc);
          //console.log(tindNrs);
          //console.log(tindBoth);
        }
        this.loadedTindakan = true;
      } catch (e) {
        //console.log(e);
      }
    },
    fetchLab: async function(tgl_periksa) {
      this.loadedLab = false;
      try {
        // let result = await this.$store.state.HTTP.get(
        //   `ranap/pemeriksaan/lab?no_rawat=${this.no_rawat}&tgl_periksa=${tgl_periksa}`
        // );
        let result = await this.$store.state.HTTP.get(
          `ranap/pemeriksaan/lab?no_rawat=${this.no_rawat}`
        );
        console.log(result);
        let self = this;
        if (result.status == "200") {
          self.lab = [];
          result.data.data
            .filter((item) => item.status != "DIBATALKAN")
            .forEach((item) => {
              item.nama = item.periksalab.nama;
              item.kode = item.periksalab.kode;
              item.id_ranap_lab = item.id;
              item.id = item.periksalab.id;
              //console.log(item.created_at);
              item.timeStamp = new Date(item.created_at).toLocaleString(
                "id-ID",
                { dateStyle: "full", timeStyle: "short", hour12: true }
              );
              self.lab.push(item);
              //console.log(new Date(item.created_at).toLocaleString());
            });
          if (result.data.data.length) {
            self.formSet.id_petugas_lab = String(
              result.data.data[0].id_petugas
            );

            self.formSet.lab_type = result.data.data[0].kategori;
          }
          //console.log(self['formSet']);
        }
      } catch (e) {
        //console.log(e);
      }
      this.loadedLab = true;
    },
    setPeriksaHarian: async function(tgl_periksa) {
      this.loadedPeriksa = false;
      //console.log(tgl_periksa);
      let resultDok = await this.$store.state.HTTP.get(
        `ranap/pemeriksaan/dokter?id_ranap=${this.$route.params.id}&tgl_periksa=${tgl_periksa}`
      );
      let resultPtg = await this.$store.state.HTTP.get(
        `ranap/pemeriksaan/petugas?id_ranap=${this.$route.params.id}&tgl_periksa=${tgl_periksa}`
      );
      //console.log(resultDok);
      //console.log(resultPtg);
      if (resultPtg.status == "200") {
        if (resultPtg.data && !isEmpty(resultPtg.data)) {
          this.form_petugas_id = resultPtg.data.id;
          let dataPetugas = setPeriksaPetugas(resultPtg.data);
          //console.log(setPeriksaPetugas(resultPtg.data));
          //console.log(dataPetugas);
          this.dataPetugasLeft = dataPetugas.left;
          this.dataPetugasRight = dataPetugas.right;
        } else {
          this.dataPetugasLeft = null;
          this.dataPetugasRight = null;
        }
      }
      if (resultDok.status == "200") {
        if (resultDok.data && !isEmpty(resultDok.data)) {
          //console.log(resultDok.data);
          this.form_dokter_id = resultDok.data.id;
          // resultDok.data.formatted_fisik = resultDok.data.fisik.replace(
          //   "public",
          //   this.backendUrl
          // );
          resultDok.data.formatted_fisik = getFullUrl(
            this.$store.state.baseStorageURL,
            resultDok.data.fisik
          );
          let result = await this.$store.state.HTTP.get(
            `ranap/pemeriksaan/dokter/${resultDok.data.id}`
          );
          //console.log(result);
          resultDok.data.rln_periksa_dok_penyakit =
            result.data.rnp_periksa_dok_penyakit;
          let dataDokter = setPeriksaDokter(resultDok.data);
          //console.log(dataDokter);

          this.dataDokterLeft = dataDokter.left;
          this.dataDokterRight = dataDokter.right;
        } else {
          this.dataDokterLeft = null;
          this.dataDokterRight = null;
        }
      }
      this.loadedPeriksa = true;
    },
    setTindakanHarian(tgl_tindakan) {
      this.tgl_tindakan = tgl_tindakan;
      this.loadedTindakan = false;
      //console.log(tgl_tindakan);
      this.fetchTindakan(tgl_tindakan);
      // this.fetchLab(tgl_tindakan);
    },
    setObatHarian(tgl_obat) {
      this.tgl_obat = tgl_obat.split(" ")[0];
      this.loadedObat = false;
      this.fetchObat();
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    if (this.$route.query.tab) {
      this.tabActive = this.$route.query.tab.toLowerCase();
    }
    this.displayData();
  },
};
</script>
<style scoped>
.tab-days .nav-item {
  margin-bottom: 0.5rem;
}
</style>
